import type { ChangeEvent, ReactNode, RefObject } from "react";
// import { SignatureModal } from "../../../components/Form/SignatureModel";
// import { AttachmentSection } from "../../../components/Form/AttachmentSection";
import type { LegalAdviceFormEightData } from "../../../types/LegalAdvices/LegalAdviceFormEight.type";
// import { DatalistInput } from "../components/dataListInput";
// import { FormActionButtons } from "../../../components/Form/FormActionButton";
// import { useSettings } from "../../../context/SettingContext";


export interface AttachmentFile {
  name: string;
  [key: string]: any;
}

export interface DetailFormDocumentProps {
  formData: LegalAdviceFormEightData;
  isEditable: boolean;
  isSigning: boolean;
  sigCanvasRef: RefObject<any>;
  setIsSigning: (isSigning: boolean) => void;
  handleChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleSaveSignature: () => void;
  renderDocumentRow: (label: string, fieldName: any) => ReactNode;
  renderDatePicker: (fieldName: any) => ReactNode;

  // Additional props required for action controls inside this component
  isPreview?: boolean;
  // isSubmitting?: boolean;
  // isApproved?: boolean;
  handleBackNavigation: () => void;
  // handleSaveDraft: (e: React.MouseEvent) => void;
  // handleSubmitToSuperior: (e: React.MouseEvent) => void;
 // handleAttachment:(e:React.MouseEvent)=> void;
}

export const LegalDetailFormEightDocument: React.FC<DetailFormDocumentProps> = ({
  formData,
//   isSigning,
//   sigCanvasRef,
//   setIsSigning,
  handleChange,
//   handleSaveSignature,
  renderDatePicker,
  // isApproved,
  // isSubmitting = false,
  // handleBackNavigation,
  // handleSaveDraft,
  // handleSubmitToSuperior,
  // handleAttachment
}) => {
  // Replace these with your actual option data sources or imports
//  const { settings } = useSettings();

//  const isFormSigned = Boolean(
//     formData.signatureImage?.trim() && 
//     (formData.signerName?.trim() || formData.signName?.trim())
//   );

// Map to simple string arrays for your dropdowns/datalists
// const OFFICE_OPTIONS = settings?.offices.map((o) => o.name) || [];
// const TOWNSHIP_OPTIONS = settings?.townships.map((t) => t.name) || [];


  return (
    <div className="w-full max-w-[850px] bg-white shadow-lg border border-gray-300 p-12 text-black space-y-12 text-xs md:text-sm leading-relaxed">
            
            {/* ခေါင်းစီးပိုင်း */}
            <div>
              <div className="text-right text-xs font-bold">ဥပရအမှုလိုက်ပုံစံ (၈)</div>
              
              <div className="text-center space-y-2 mt-2">
                <h1 className="text-base font-bold">ပြည်ထောင်စုသမ္မတမြန်မာနိုင်ငံတော်အစိုးရ</h1>
                <h2 className="text-sm font-bold">ပြည်ထောင်စုရှေ့နေချုပ်ရုံး</h2>
                
                <div className="flex justify-center items-center gap-1">
                  {/* <input 
                    type="text" 
                    name="regionOrState" 
                    value={formData.regionOrState} 
                    onChange={handleChange} 
                    placeholder="" 
                    className="w-24 bg-transparent border-b border-black text-center focus:outline-none font-bold" 
                  /> */}
                  <span className="font-bold">တိုင်းဒေသကြီး / ပြည်နယ်ဥပဒေချုပ်ရုံး</span>
                </div>
    
                <h3 className="text-sm font-bold pt-4 text-center max-w-xl mx-auto leading-normal">
                  အပြီးပြတ်လွတ်သည့်အမိန့်ကို အယူခံဝင်ရန် သင့် မသင့် တိုင်းဒေသကြီး/ ပြည်နယ်<br />
                  ဥပဒေချုပ်ရုံးက စိစစ်ခြင်း
                </h3>
              </div>
    
              {/* အပိုင်း ၁။ စိစစ်ချက်အချက်အလက်များ (၁ မှ ၇) */}
              <div className="mt-8 space-y-4">
                <div className="flex items-baseline">
                  <span className="w-10 font-bold">၁။</span>
                  <span className="w-80">ဥပဒေချုပ်ရုံးက စိစစ်သည့် အမှုတွဲအမှတ်</span>
                  <input type="text" name="scrutinyCaseNo" value={formData.scrutinyCaseNo} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none px-2" />
                </div>
    
                <div className="flex items-baseline">
                  <span className="w-10 font-bold">၂။</span>
                  <span className="w-80">ဥပဒေချုပ်ရုံး၏ အယူခံဝင်ရန်သင့် မသင့် စိစစ်ခြင်းမှတ်ပုံတင်အမှတ်စဉ်</span>
                  <input type="text" name="scrutinyRegisterNo" value={formData.scrutinyRegisterNo} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none px-2" />
                </div>
    
                <div className="flex items-baseline">
                  <span className="w-10 font-bold">၃။</span>
                  <span className="w-80">တင်ပြသူ / တင်ပြသည့်ရုံးအမည်</span>
                  <input type="text" name="submitterNameOrOffice" value={formData.submitterNameOrOffice} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none px-2" />
                </div>
    
                <div className="flex flex-col space-y-1">
                  <div className="flex items-baseline">
                    <span className="w-10 font-bold">၄။</span>
                    <span className="flex-1">အပြီးပြတ်လွတ်သည့် တရားရုံးအမည် နှင့် အမှုအမှတ်၊ အမိန့်၊ ရက်စွဲ</span>
                  </div>
                  <textarea name="acquittalCourtDetails" value={formData.acquittalCourtDetails} onChange={handleChange} rows={2} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none mt-1" />
                </div>
    
                <div className="flex items-baseline">
                  <span className="w-10 font-bold">၅။</span>
                  <span className="w-80">တရားစွဲဆိုသည့်ဥပဒေ၊ ပုဒ်မ</span>
                  <input type="text" name="prosecutedLawSection" value={formData.prosecutedLawSection} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none px-2" />
                </div>
    
                <div className="flex items-baseline">
                  <span className="w-10 font-bold">၆။</span>
                  <span className="w-80">စွဲချက်တင်သည့် ဥပဒေ၊ ပုဒ်မ</span>
                  <input type="text" name="chargedLawSection" value={formData.chargedLawSection} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none px-2" />
                </div>
    
                <div className="flex items-baseline">
                  <span className="w-10 font-bold">၇။</span>
                  <span className="w-80">အယူခံဝင်ရန် ကာလစည်းကမ်းသတ် ကုန်ဆုံးသည့်ရက်စွဲ</span>
                  <input type="text" name="limitationExpiryDate" value={formData.limitationExpiryDate} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none px-2" />
                </div>
    
                {/* အမှတ်စဉ် ၈။ သုံးသပ်တင်ပြချက်များ */}
                <div className="flex flex-col space-y-3 pt-2">
                  <div className="flex items-baseline">
                    <span className="w-10 font-bold">၈။</span>
                    <span className="font-bold flex-1">ကနဦး စိစစ်သည့် ဥပဒေအရာရှိ၏ သုံးသပ်တင်ပြချက်</span>
                  </div>
    
                  <div className="pl-6 flex flex-col space-y-1">
                    <label className="font-medium">(က) တရားလိုဘက်မှ တင်ပြချက်များ အပေါ် သုံးသပ်ချက်</label>
                    <textarea name="plaintiffArgumentAnalysis" value={formData.plaintiffArgumentAnalysis} onChange={handleChange} rows={3} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none mt-1" />
                  </div>
    
                  <div className="pl-6 flex flex-col space-y-1">
                    <label className="font-medium">(ခ) တရားခံဘက်မှ တင်ပြချက်များ အပေါ် သုံးသပ်ချက်</label>
                    <textarea name="defendantArgumentAnalysis" value={formData.defendantArgumentAnalysis} onChange={handleChange} rows={3} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none mt-1" />
                  </div>
    
                  <div className="pl-6 flex flex-col space-y-1">
                    <label className="font-medium">(ဂ) တရားရုံး စီရင်ချက် (များ) အပေါ် သုံးသပ်ချက်</label>
                    <textarea name="courtJudgmentAnalysis" value={formData.courtJudgmentAnalysis} onChange={handleChange} rows={3} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none mt-1" />
                  </div>

                  <div className="pl-6 flex flex-col space-y-1">
                    <label className="font-medium">(ဃ) နှစ်ဘက်တင်ပြချက်များ နှင့်စပ်လျဉ်း၍ အယူခံဝင်ရန် သင့် မသင့် သုံးသပ်တင်ပြချက်</label>
                    <textarea name="courtJudgmentAnalysis" value={formData.courtJudgmentAnalysis} onChange={handleChange} rows={3} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none mt-1" />
                  </div>

                  {/* handling officer*/}
                  <div className="flex flex-col items-end pt-2">
                    <div className="w-64 space-y-2">
                      <div className="flex items-center">
                        <span className="w-24 text-right text-xs mr-2">လက်မှတ်</span>
                        <div 
                        // onClick={() => handleOpenSignatureModal('handling')}
                         className="flex-1 bg-transparent border-b border-dotted border-black min-h-[32px] flex items-center justify-center cursor-pointer hover:bg-gray-50 relative">
                          {formData.handlingOfficerSignature ? (
                            <img src={formData.handlingOfficerSignature} alt="Handling Sign" className="h-8 object-contain" />
                          ) : (
                            <span className="text-gray-400 text-xs">✍️ လက်မှတ်ထိုးရန်</span>
                          )}
                          {formData.handlingOfficerSignature && (
                            <button
                              type="button"
                              // onClick={handleClearHandlingSignature}
                              title="လက်မှတ်ရှင်းလင်းမည်"
                              className="absolute -right-6 text-slate-400 hover:text-rose-500 text-xs px-1 font-bold z-10 print:hidden"
                            >
                              ✕
                            </button>
                          )}
                        </div>
                      </div>
                      <div className="flex items-center">
                        <span className="w-24 text-right text-xs mr-2">အမည်</span>
                        <input type="text" name="handlingOfficerName" value={formData.handlingOfficerName} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" />
                      </div>
                      <div className="text-center text-xs font-bold pt-1">အမှုလိုက်ဥပဒေအရာရှိ</div>
                      <div className="flex items-center">
                        <span className="w-32 shrink-0 whitespace-nowrap text-right text-xs mr-2">လက်ခံရရှိသည့်ရက်စွဲ</span>
                        <div className="flex-grow">{renderDatePicker('handlingOfficerReceivedDate')}</div>
                      </div>
                      <div className="flex items-center">
                        <span className="w-32 shrink-0 whitespace-nowrap text-right text-xs mr-2">တင်ပြသည့်ရက်စွဲ</span>
                        <div className="flex-grow">{renderDatePicker('handlingOfficerSubmitDate')}</div>
                        {/* <input type="text" name="handlingOfficerSubmitDate" value={formData.handlingOfficerSubmitDate} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" /> */}
                      </div>

                      
                    </div>
                  </div>
                </div>

                 {/* incharge officer*/}
                <div className="flex flex-col space-y-1">
                  <div className="flex items-baseline">
                    <span className="w-10 font-bold">၉။</span>
                    <span className="font-bold flex-1">တိုင်းဒေသကြီး/ ပြည်နယ်ဥပဒေအရာရှိ၏ သဘောထားမှတ်ချက်</span>
                  </div>
                  <textarea name="inChargeOfficerOpinion" value={formData.inChargeOfficerOpinion} onChange={handleChange} rows={4} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none mt-1" />


                  <div className="flex flex-col items-end pt-2">
                    <div className="w-64 space-y-2">
                      <div className="flex items-center">
                        <span className="w-24 text-right text-xs mr-2">လက်မှတ်</span>
                        <div
                        //  onClick={() => handleOpenSignatureModal('inCharge')} 
                         className="flex-1 bg-transparent border-b border-dotted border-black min-h-[32px] flex items-center justify-center cursor-pointer hover:bg-gray-50 relative">
                          {formData.inChargeOfficerSignature ? (
                            <img src={formData.inChargeOfficerSignature} alt="inCharge Sign" className="h-8 object-contain" />
                          ) : (
                            <span className="text-gray-400 text-xs">✍️ လက်မှတ်ထိုးရန်</span>
                          )}
                          {formData.inChargeOfficerSignature && (
                            <button
                              type="button"
                              // onClick={handleClearInchargeSignature}
                              title="လက်မှတ်ရှင်းလင်းမည်"
                              className="absolute -right-6 text-slate-400 hover:text-rose-500 text-xs px-1 font-bold z-10 print:hidden"
                            >
                              ✕
                            </button>
                          )}
                        </div>
                      </div>
                      <div className="flex items-center">
                        <span className="w-24 text-right text-xs mr-2">အမည်</span>
                        <input type="text" name="inChargeOfficerName" value={formData.inChargeOfficerName} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" />
                      </div>
                      <div className="text-center text-xs font-bold pt-1">တာဝန်ခံဥပဒေအရာရှိ</div>
                      <div className="flex items-center">
                        <span className="w-32 shrink-0 whitespace-nowrap text-right text-xs mr-2">လက်ခံရရှိသည့်ရက်စွဲ</span>
                        <div className="flex-grow">{renderDatePicker('inChargeOfficerReceivedDate')}</div>
                      </div>
                      <div className="flex items-center">
                        <span className="w-32 shrink-0 whitespace-nowrap text-right text-xs mr-2">တင်ပြသည့်ရက်စွဲ</span>
                        <div className="flex-grow">{renderDatePicker('inChargeOfficerSubmitDate')}</div>
                        {/* <input type="text" name="handlingOfficerSubmitDate" value={formData.handlingOfficerSubmitDate} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" /> */}
                      </div>
                    </div>
                  </div>
                </div>

                  {/* region officer*/}
                <div className="flex flex-col space-y-1">
                  <div className="flex items-baseline">
                    <span className="w-10 font-bold">၁၀။</span>
                    <span className="font-bold flex-1">တိုင်းဒေသကြီး/ ပြည်နယ်ဥပဒေချုပ်၏ ဆုံးဖြတ်ချက်</span>
                  </div>
                  <textarea name="regionOfficerOpinion" value={formData.regionOfficerOpinion} onChange={handleChange} rows={4} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none mt-1" />


                  <div className="flex flex-col items-end pt-2">
                    <div className="w-64 space-y-2">
                      <div className="flex items-center">
                        <span className="w-24 text-right text-xs mr-2">လက်မှတ်</span>
                        <div
                        //  onClick={() => handleOpenSignatureModal('region')}
                          className="flex-1 bg-transparent border-b border-dotted border-black min-h-[32px] flex items-center justify-center cursor-pointer hover:bg-gray-50 relative">
                          {formData.regionOfficerSignature ? (
                            <img src={formData.regionOfficerSignature} alt="In-charge Sign" className="h-8 object-contain" />
                          ) : (
                            <span className="text-gray-400 text-xs">✍️ လက်မှတ်ထိုးရန်</span>
                          )}
                          {formData.regionOfficerSignature && (
                            <button
                              type="button"
                              // onClick={handleClearRegionSignature}
                              title="လက်မှတ်ရှင်းလင်းမည်"
                              className="absolute -right-6 text-slate-400 hover:text-rose-500 text-xs px-1 font-bold z-10 print:hidden"
                            >
                              ✕
                            </button>
                          )}
                        </div>
                      </div>
                      <div className="flex items-center">
                        <span className="w-24 text-right text-xs mr-2">အမည်</span>
                        <input type="text" name="regionOfficerName" value={formData.regionOfficerName} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" />
                      </div>
                      <div className="text-center text-xs font-bold pt-1">တိုင်းဒေသကြီး/ ပြည်နယ်ဥပဒေချုပ်</div>
                      <div className="flex items-center">
                        <span className="w-32 shrink-0 whitespace-nowrap text-right text-xs mr-2">ဆုံးဖြတ်သည့်ရက်စွဲ</span>
                        <div className="flex-grow">{renderDatePicker('regionOfficerSubmitDate')}</div>
                        {/* <input type="text" name="inChargeOfficerSubmitDate" value={formData.inChargeOfficerSubmitDate} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" /> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

    
          </div>
  );
};